<div style="display: flex; flex-flow: row nowrap;">
    <div style="flex-grow: 1;">
        <h3 i18n>Total amount</h3>
        <p>{{ transaction.amount | currency: transaction.currency.code }}
    </div>

    <div style="flex-grow: 1;">
    <h3 i18n>Reference</h3>
    <p>{{ transaction.reference }}</p>
    </div>

    <div style="flex-grow: 1;" *ngIf="transaction.method">
    <h3 i18n>Paid by</h3>
    <p>{{ transaction.method.displayName }}</p>
    </div>
</div>

<h2 i18n>Confirm payment</h2>
<p i18n>
    Use the button below to confirm that payment has been received for this transaction.
</p>
<form action="/transactions/{{transaction.id}}/capture"
      method="post"
      [formGroup]="form">
    <div class="form-row">
        <h3 i18n>Payment method</h3>
        <p>
            <select formControlName="method">
                <option value="" disabled selected i18n>Select payment method...</option>
                <option *ngFor="let method of availablePaymentMethods"
                        [ngValue]="method.id">{{ method.displayName ?? method.doc._id }}</option>
            </select>
        </p>
    </div>
    <ub-button-list>
      <button mat-flat-button
              color="primary"
              type="button"
              (click)="onConfirm()"
              [disabled]="!form.valid || isOperationInProgress" i18n>Confirm Payment!</button>
    </ub-button-list>
</form>
